<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            <div v-for="(n, i) in quizs" :class="`tx-white tx-24 tx-semibold`" >
              <div role="button" class="rounded-20 pd-30 d-flex" :style="`min-height: 300px; height: 40vh; ${n.st1}; position: relative`">
                {{ n.task }}
                <div :style="`left: 50%; transform: translate(-50%, 0%); bottom: 0px; position: absolute; width: 100%; height: 80%; background-image: url('${n.defaultAttachmentUrl}'); background-size: contain; background-repeat: no-repeat; background-position: center`"></div>
                <div @click="startQuiz(n)" v-if="n.defaultFormId>0" class="px-8 transform -translate-x-1/2 pos-absolute b-20 tx-white tx-14 pd-y-10 md:px-4 rounded-40 left-1/2" 
                  style="background: rgba(255,255,255,0.3)">
                  Шалгалт өгөх
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 20411 -->
      </vue-custom-scrollbar>
    </div>

    </div>




    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      quizs: [],
      
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    startQuiz(task){
      this.$router.push({
        name: "examOnline",
        params: {
          courseId: task.id,
          // courseId: -500,
          formId: task.defaultFormId,
          // formId: 20411,
          lessonId: 0,
          boxId: 0,
          boxOt: 616,
        },
      });
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      let _pid = 0;
      let proj = this.$store.state.app.groupDefaultProjects.filter((x) => x.objectTypeId == 616);
      if (proj.length) {
        _pid = proj[0].id;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            projectId: _pid,
            skip: 0,
            size: 100,
            id: 0,
            model: {
              isPublic: true
            },
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            this.quizs= res.data.tasks;
            //console.log('res.data.tasks', res.data.tasks);
          }
        });
      }
    },
    
  },
};
</script>
<style>
</style>